import { Link } from "react-router-dom";
import { useSiteContent } from "../context/SiteContentContext";
import { CLINIC, CLINIC2 } from "../data/content";
import { MapPin, Phone, Clock, ShieldCheck } from "lucide-react";

export const Footer = () => {
  const { clinic } = useSiteContent();
  return (
  <footer className="bg-[#2C557E] text-white mt-auto" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div>
        <h3 className="font-heading font-semibold text-lg">Dr. Prathusha K</h3>
        <p className="text-sm text-blue-100 mt-2 leading-relaxed">
          {CLINIC.credentials}. Compassionate, evidence-based women's healthcare in Banjara Hills,
          Hyderabad — from preconception planning through pregnancy and advanced gynaecological care.
        </p>
      </div>
      <div>
        <h4 className="font-heading font-medium text-sm uppercase tracking-wider text-[#E8DAB2]">
          Quick Links
        </h4>
        <ul className="mt-3 space-y-2 text-sm text-blue-100">
          <li><Link to="/about" className="hover:text-white">About Dr. Prathusha</Link></li>
          <li><Link to="/services" className="hover:text-white">Services</Link></li>
          <li><Link to="/booking" className="hover:text-white">Book an Appointment</Link></li>
          <li><Link to="/online-consultation" className="hover:text-white">Online Consultation</Link></li>
          <li><Link to="/resources" className="hover:text-white">Patient Resources</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-medium text-sm uppercase tracking-wider text-[#E8DAB2]">
          For Consultations Visit Us
        </h4>
        <ul className="mt-3 space-y-3 text-sm text-blue-100">
          <li className="flex gap-2">
            <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
            <span>
              <b className="text-white font-medium">Care Hospitals</b><br />
              {clinic.address}<br />
              <span className="text-blue-200">{clinic.hours}</span>
            </span>
          </li>
          <li className="flex gap-2">
            <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
            <span>
              <b className="text-white font-medium">{CLINIC2.name}</b><br />
              {CLINIC2.address}<br />
              <span className="text-blue-200">{CLINIC2.hours}</span>
            </span>
          </li>
          <li className="flex gap-2"><Phone className="w-4 h-4 shrink-0 mt-0.5" /><a href={clinic.phoneHref} className="hover:text-white">{clinic.phone}</a></li>
          <li className="flex gap-2"><Clock className="w-4 h-4 shrink-0 mt-0.5" />Online consultations: {clinic.onlineHours}</li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-medium text-sm uppercase tracking-wider text-[#E8DAB2]">
          Privacy & Compliance
        </h4>
        <p className="mt-3 text-xs text-blue-100 leading-relaxed flex gap-2">
          <ShieldCheck className="w-4 h-4 shrink-0 mt-0.5" />
          Your health data is encrypted in transit and accessible only to you and your doctor, in
          line with the Digital Personal Data Protection Act, 2023. Online consultations follow the
          Telemedicine Practice Guidelines, 2020 (NMC). This portal is not for medical emergencies —
          in an emergency, please visit the nearest hospital immediately.
        </p>
        <div className="mt-5 space-y-2 text-xs text-blue-200">
          <Link
            to="/professional/login"
            data-testid="footer-professional-login"
            className="block hover:text-white"
          >
            Professional Login →
          </Link>
          <Link
            to="/login?role=admin"
            data-testid="footer-admin-login"
            className="block hover:text-white"
          >
            Admin Login →
          </Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/15 py-4 text-center text-xs text-blue-200">
      © {new Date().getFullYear()} Dr. Prathusha K · drprathushak.in · All rights reserved
    </div>
  </footer>
  );
};
